export const OPEN = 'WALKTHRU_OPEN';
export const CLOSE = 'WALKTHRU_CLOSE';
export const RESET = 'WALKTHRU_RESET';
export const SET_STEPS = 'WALKTHRU_SET_STEPS';



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/walkthru/walkthru-constants.js